module.exports = __webpack_public_path__ + "static/media/svTattoo.fa25306b.png";